import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import TripticLanding from "../../pages/TripticLanding";
import { resolvePortalPath, type PortalPath } from "../../services/portalRouting";

// If signed in, send to whichever portal the user actually has a profile row in.
// If not signed in, render landing page.
const LandingRedirect = () => {
  console.log('[LandingRedirect] Rendered. URL:', window.location.href)

  const { session } = UserAuth();
  const [target, setTarget] = useState<PortalPath | null>(null);

  useEffect(() => {
    const authUserId = session?.user?.id;
    if (!authUserId) {
      setTarget(null);
      return;
    }

    let cancelled = false;
    resolvePortalPath(authUserId).then(path => {
      if (!cancelled) setTarget(path);
    });

    return () => { cancelled = true };
  }, [session]);

  // CRITICAL: If URL has OAuth hash fragment (access_token / refresh_token),
  // forward to /auth/callback so AuthCallback can run the role-lock checks
  // BEFORE we route to a portal. Otherwise OAuth signups bypass all checks.
  if (typeof window !== 'undefined') {
    const search = window.location.search || ''
    const hash = window.location.hash || ''

    // Handle PKCE flow: ?code= query param
    if (search.includes('code=')) {
      console.log('[LandingRedirect] PKCE code detected — forwarding to /auth/callback')
      window.location.replace('/auth/callback' + search)
      return null
    }

    // Handle implicit flow fallback: #access_token= hash fragment
    if (hash.includes('access_token=') || hash.includes('refresh_token=')) {
      console.log('[LandingRedirect] OAuth hash detected — forwarding to /auth/callback')
      window.location.replace('/auth/callback' + hash)
      return null
    }
  }

  if (session === undefined) return null;
  if (!session) return <TripticLanding />;

  // Still checking which portal this user belongs to
  if (!target) return null;

  return <Navigate to={target} replace />;
};

export default LandingRedirect;
